'use client'

import { usePathname } from 'next/navigation'
import { useLayoutEffect } from 'react'

import { getLocaleFromPathname } from './config'
import { getLocaleFontClassNames, notoSansScClassName } from './getLocaleFontClassNames'

/** Keeps Noto on `<html>` when the locale prefix changes via client navigation. */
export function LocaleFontClassClient({ notoVariableClass }: { notoVariableClass: string }) {
  const pathname = usePathname()

  useLayoutEffect(() => {
    const html = document.documentElement
    const extra = getLocaleFontClassNames(getLocaleFromPathname(pathname))
    html.classList.remove(notoVariableClass, notoSansScClassName)
    if (extra) {
      html.classList.add(notoVariableClass, extra)
    }
  }, [pathname, notoVariableClass])

  return null
}
